export enum DeviceType {
    Desktop,
    Tablet,
    Mobile
}
